import React, {useEffect, useState} from 'react';
import {useProductDetailData, useRelatedProductsData} from '../hooks/useProductDetailData';
import TakisProductDetailHero from "../components/TakisProductDetailHero";
import TakisGrid from "../components/TakisGrid";
import TakisProductHeroSkeleton from "../components/Skeletons/TakisProductHeroSkeleton";
import TakisGridSkeleton from "../components/Skeletons/TakisGridSkeleton"

const ProductDetail = ({pagePath}) => {
  //Product Detail Page Data
  const [productDetailData, setProductDetailData] = useState('');
  //Product Detail Hero Query Data
  const { error, isLoading, productDetailQueryData } = useProductDetailData(pagePath);
  //Related Products Query Data
  const [productId, setProductId] = useState(null)
  const [viewRelatedProduct, setViewRelatedProduct] = useState('')
  const { relatedProductsQueryData } =
    useRelatedProductsData(productId, viewRelatedProduct);

  // FIXME: create Loader for Related Product Grid
  // const { relatedProductsError, relatedProductsIsLoading, relatedProductsQueryData } =
  //   useRelatedProductsData(productId, viewRelatedProduct);
  // const isLoadingRelatedProducts = relatedProductsError || relatedProductsIsLoading || !relatedProductsQueryData
  const isLoadingHero = isLoading || error || !productDetailData

  useEffect(() => {
    if (productDetailQueryData) {
      setProductDetailData(productDetailQueryData);
      setProductId(productDetailQueryData.productId);
      setViewRelatedProduct(productDetailQueryData.viewRelatedProduct);
    }
  }, [productDetailQueryData]);

  useEffect(() => {
    if (relatedProductsQueryData) {
      setProductDetailData((prevState) => ({...prevState, ...relatedProductsQueryData}))
    }
  }, [relatedProductsQueryData]);


  if (isLoadingHero) {
    return (
      <>
        <TakisProductHeroSkeleton />
        <TakisGridSkeleton/>
      </>
    );
  }
  return (
    <>
      <div>
        {
          productDetailData.hero &&
          <TakisProductDetailHero
            heroImageDesktopSrc={productDetailData.hero.heroImageDesktopSrc}
            heroImageMobileSrc={productDetailData.hero.heroImageMobileSrc}
            heroImageTopBackgroundDesktopSrc={productDetailData.hero.heroImageTopBackgroundDesktopSrc}
            heroImageTopBackgroundMobileSrc={productDetailData.hero.heroImageTopBackgroundMobileSrc}
            heroImageBottomBackgroundSrc={productDetailData.hero.heroImageBottomBackgroundSrc}
            heroImageAlt={productDetailData.hero.heroImageAlt}
            title={productDetailData.hero.title}
            heroParagraph={productDetailData.hero.heroParagraph}
            firstCta={productDetailData.hero.firstCta}
            secondCta={productDetailData.hero.secondCta}
            nutritionCta={productDetailData.hero.nutritionCta}
          />
        }
        {
          (productDetailData.gridCategory && productDetailData.gridCategory.items) &&
          <TakisGrid
            title={productDetailData.viewRelatedProduct.title}
            items={productDetailData.gridCategory.items}
          />
        }

      </div>
    </>
  );
};

export default ProductDetail;
